<template lang="pug">
div(
  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-full tw-text-center tw-p-4"
  :class="{ 'tw-p-2': compact }"
)
  div(role="status" aria-live="polite" class="tw-flex tw-flex-col tw-items-center")
    v-img(
      v-if="illustration"
      :src="illustration"
      :max-width="compact ? 72 : 150"
      class="tw-mb-3 tw-opacity-80"
      alt=""
      aria-hidden="true"
    )
    v-icon(v-else :size="compact ? 32 : 48" color="blue-grey lighten-2" class="tw-mb-3" aria-hidden="true") {{ icon }}
    h3(class="tw-m-0 tw-font-bold tw-text-gray-darken-2" :class="compact ? 'tw-text-sm' : 'tw-text-lg'") {{ title }}
    div(v-if="description" class="tw-text-sm tw-text-blueGray-base tw-mt-1 tw-max-w-md") {{ description }}
  v-btn(
    v-if="actionLabel"
    text
    color="primary"
    class="tw-mt-2"
    @click="$emit('action')"
  ) {{ actionLabel }}
</template>

<script>
export default {
  name: 'KubiqaEmptyState',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    actionLabel: { type: String, default: '' },
    icon: { type: String, default: 'mdi-inbox-outline' },
    illustration: { type: String, default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>
